import FormBuilderModel from "~/models/tracked/formBuilderModel";

export default class FormBuilderSortable extends FormBuilderModel {
  sort_order: number;

  get isFirst() {
    return this === this.parent.sortProperty(this.rootName)[0];
  }

  get isLast() {
    const sorted = this.parent.sortProperty(this.rootName);
    return this === sorted[sorted.length - 1];
  }

  moveDown(): void {
    if (!this.isLast) {
      this.sort_order++;
      this.parent.updateSortOrder(this.rootName, this, this.sort_order);
    }
  }

  moveUp(): void {
    if (!this.isFirst) {
      this.sort_order--;
      this.parent.updateSortOrder(this.rootName, this, this.sort_order);
    }
  }
}
